import { Injectable, inject } from '@angular/core';
import { AdministratorInCamelCase, AdministratorsQueryParams, PagedResponse } from 'mbs-ui-shared@models';
import { AdministratorService } from 'mbs-ui-shared@services/administrator.service';
import { Observable, tap } from 'rxjs';
import { AdministratorsStore } from '../store/administrators/administratorsStore';
import { PagingAndDataFacade } from '../store/withPagingAndDataStoreFeature/pagingAndData.facade';

@Injectable({
  providedIn: 'root'
})
export class AdministratorsFacade extends PagingAndDataFacade<AdministratorInCamelCase> {
  protected override store = inject(AdministratorsStore);
  private administratorService = inject(AdministratorService);

  private readonly administratorNameField = 'email';

  public create(admin: AdministratorInCamelCase): Observable<AdministratorInCamelCase> {
    return this.administratorService.createAdministrator(admin).pipe(tap(() => this.invalidateEntities()));
  }

  public update(admin: AdministratorInCamelCase): Observable<AdministratorInCamelCase> {
    return this.administratorService.updateAdministrator(admin).pipe(tap((admin) => this.invalidateEntities(admin)));
  }

  public delete(admin: AdministratorInCamelCase): Observable<null> {
    return this.administratorService.deleteAdministrator(admin?.id).pipe(tap(() => this.invalidateEntities()));
  }

  public getAdministrators(params?: AdministratorsQueryParams): Observable<PagedResponse<AdministratorInCamelCase>> {
    return this.administratorService.get(params);
  }

  private invalidateEntities(admin?: AdministratorInCamelCase): void {
    this.refreshAfterCRUD(admin, this.administratorNameField);
  }
}
